import { GlucoseAPI } from './types'

export const glucoseApi: GlucoseAPI = ky => {
  return {
    async fetchSetting({ patientId }) {
      return ky(`patient/${patientId}/glucose_setting/`, {
        method: 'get'
      }).json()
    },

    async putSetting({ patientId, payload }) {
      return ky(`patient/${patientId}/glucose_setting/`, {
        method: 'put',
        body: JSON.stringify(payload)
      }).json()
    },

    async patchSetting({ patientId, payload }) {
      return ky(`patient/${patientId}/glucose_setting/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    }
  }
}
